angular.module('bb.appointments.feedback').component('bbQuestionEditModal', {
  transclude: true,
  bindings: {},
  controller: QuestionEditModalController,
  controllerAs: 'vm',
  template: require('./question_edit_modal.html'),
});

QuestionEditModalController.$inject = ['ModalService'];
function QuestionEditModalController(ModalService) {
  const vm = this;

  vm.questionEditModal = ModalService.questionEditModal;

  vm.closeModal = function () {
    ModalService.closeQuestionEditModal();
  };
}
